import { Injectable } from '@angular/core';
import { MentionMePlace } from '@df/module-mention-me/mention-me.interfaces';
import { MentionMeService } from '@df/module-mention-me/mention-me.service';
@Injectable()
export class LocalMentionMeService extends MentionMeService {
    protected override getApiBaseUrl(place: MentionMePlace, mmid: string) {
        const domain = this.app.dfConfig.environment === 'production' ? 'tag.mention-me.com' : 'tag-demo.mention-me.com';
        return '//' + domain + '/api/v2/' + place + '/' + mmid;
    }
}
